const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const getCurrencyFormatter = (): Intl.NumberFormat => {
  return currencyFormatter;
};

export const formatSecondsCountdown = (seconds: number): string => {
  return `00:${String(seconds).padStart(2, '0')}`;
};
